/**
 * V83 — "Refiere y gana" (Configuración, solo admin): muestra el referral_code
 * del tenant (solo lectura, asignado al signup) + botón copiar + explicación
 * del beneficio de dos lados: el referido obtiene −10% en su primer periodo
 * (cupón referido10, V80) y el referente −10% de su base en su siguiente
 * periodo (crédito V83, una recompensa por periodo, al confirmarse el primer
 * pago del referido).
 */
import { useState } from 'react';
import { useAuth } from '../auth/AuthProvider';

export function ReferralCard() {
  const { user } = useAuth() as any;
  const [copied, setCopied] = useState(false);
  const code: string | null = user?.tenant?.referralCode ?? null;

  if (!code) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch { /* clipboard no disponible: el código queda visible para copiar a mano */ }
  };

  return (
    <div className="card-soft rounded-2xl border border-slate-200/80 bg-white">
      <div className="border-b border-slate-100 px-6 py-5 md:px-8">
        <h3 className="font-serif text-lg tracking-tight text-slate-900">Refiere y gana</h3>
        <p className="text-sm text-slate-500">
          Comparte tu código: quien se registre con él obtiene <strong>−10% en su primer periodo</strong>,
          y tú recibes <strong>−10% en tu siguiente periodo</strong> cuando su pago se confirme.
        </p>
      </div>
      <div className="flex flex-wrap items-center gap-3 px-6 py-5 md:px-8">
        <span className="rounded-xl border border-slate-200 bg-slate-50 px-4 py-2 font-mono text-lg font-semibold tracking-widest text-slate-900">
          {code}
        </span>
        <button
          onClick={copy}
          className="rounded-xl bg-[var(--brand-primary)] px-3 py-2 text-sm font-medium text-[var(--brand-primary-fg)] hover:bg-[var(--brand-primary-hover)]">
          {copied ? 'Copiado ✓' : 'Copiar'}
        </button>
        <span className="text-[11px] text-slate-400">
          Se captura en el registro (campo "Código de referido"). Una recompensa por cada referido
          que pague; se aplican una por periodo.
        </span>
      </div>
    </div>
  );
}
